import {useReCaptcha} from 'vue-recaptcha-v3';

export default function useGoogleRecaptcha() {
	const {isSpeedMode} = useSpeedMode();

	const recaptchaInstance = isSpeedMode.value ? null : useReCaptcha();

	async function executeRecaptcha(action: string) {
		if (isSpeedMode.value) { return {token: undefined}; }
		await recaptchaInstance?.recaptchaLoaded();
		const token = await recaptchaInstance?.executeRecaptcha(action);
		return {token};
	}

	return {executeRecaptcha};
}
